const filterConfig = [
  {
    name: 'dateFrom',
    type: 'date'
  },
  {
    name: 'dateEnd',
    type: 'date'
  },
  {
    name: 'docId',
    type: 'text'
  }
];

export default filterConfig;
